import { Component } from '@angular/core';
import { SocketService } from '../socket.service';
import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-open-sesame',
  templateUrl: './open-sesame.component.html',
  styleUrls: ['./open-sesame.component.scss']
})
export class OpenSesameComponent {

  constructor(
    private socket: SocketService,
    private AuthenticationService: AuthenticationService,

  ){
    this.socket.onmessage( (ev) => { 

			let message = JSON.parse(ev.data);
			console.log(message);

			if(message.doorRequest === 'granted') {
				console.log('awesome')
      }

      if(message.doorStatus) {
				this.doorStatus = message.doorStatus;
				console.log('doorStatus', message.doorStatus)
      }
    });

    this.socket.connect();

  }

  ngOnInit() {
    this.AuthenticationService.startBeacon()
    const zedderId = this.AuthenticationService.getUser().details?.id;
    console.log(zedderId);
  }

  doorStatus = 'unknown';

  requestDoor() {
    this.socket.send({ 
      openSesame: { 
        id: String(this.AuthenticationService.getUser().details?.id).padStart(5, '0'), 
        name: this.AuthenticationService.getUser().details?.firstname + ' ' + this.AuthenticationService.getUser().details?.lastname 
      } 
    });
  }
}
